import { render, staticRenderFns } from "./RegisteredPhone.vue?vue&type=template&id=156b63ec&scoped=true&"
import script from "./RegisteredPhone.vue?vue&type=script&lang=js&"
export * from "./RegisteredPhone.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredPhone.vue?vue&type=style&index=0&id=156b63ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156b63ec",
  null
  
)

export default component.exports